import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import IconButton from '../IconButton';
import IconWrap from '../IconWrap';
import Icon from '../Icon';
import Typography from '../Typography';
import { StyledPagination, StylesInputPage } from './styled';
import { makeStyles } from '../../utils/styles';

const useStyles = makeStyles(css => ({
    iconButtonLeft: css`
        padding: 6px 20px 6px 0;
    `,
    iconButtonRight: css`
        padding: 6px 0 6px 20px;
    `,
    typograpy: css`
        margin: 0 10px;
    `
}));

const Pagination = ({ pageIndex, pageLength, canPreviousPage, canNextPage, previousPage, nextPage, gotoPage }) => {
    const styles = useStyles();
    const refInput = useRef(null);

    useEffect(() => {
        refInput.current.value = pageIndex;
    }, [pageIndex])

    const handleChangePage = e => {
        const page = e.target.value ? Number(e.target.value) - 1 : 0;
        gotoPage(page);
    };

    return (
        <StyledPagination>
            {
                pageIndex > 0 && canPreviousPage &&
                <IconButton
                    customStyle={styles.iconButtonLeft}
                    onClick={previousPage}
                >
                    <IconWrap rotate={-90}>
                        <Icon name="arrow" />
                    </IconWrap>
                </IconButton>
            }
            <StylesInputPage
                ref={refInput}
                type="number"
                defaultValue={pageIndex}
                min={1}
                max={pageLength}
                onChange={handleChangePage}
            />
            <Typography
                as="p"
                customStyle={styles.typograpy}
            >
                {'z'}
            </Typography>
            <Typography
                as="p"
            >
                {pageLength}
            </Typography>
            {
                canNextPage &&
                <IconButton
                    customStyle={styles.iconButtonRight}
                    onClick={nextPage}
                >
                    <IconWrap rotate={90}>
                        <Icon name="arrow" />
                    </IconWrap>
                </IconButton>
            }
        </StyledPagination>
    );
};

Pagination.propTypes = {
    pageIndex: PropTypes.number,
    pageLength: PropTypes.number,
    previousPage: PropTypes.func,
    canPreviousPage: PropTypes.bool,
    canNextPage: PropTypes.bool,
    nextPage: PropTypes.func,
    gotoPage: PropTypes.func
};

Pagination.defaultProps = {
    pageIndex: 0,
    pageLength: 0
};

export default React.memo(Pagination);